export const REFERRER_QUERY_PARAM = 'referrer';

export const SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE = 'overviewCreateRequest';
export const GETTING_STARTED_PAGE_LEARN_BY_DOING = 'gettingStartedPageLearnByDoing';
export const YOUR_WORK = 'yourWork';
